import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { taskRequestHoursForAdd, taskRequestHoursForUpdate } from './interfaces/taskRequestHoursClass';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../common/Toastr';
import fetchAPI from '../../common/fetchAPI';
import Select, { StylesConfig } from 'react-select';
import { addAccountTaskRequestasync } from './taskRequestHoursSlice';
import { determineCommaSeprater, FormatInvoiceDecimalNumber, getValueFromResource, parseLocalizedNumber } from '../../common/timeLiveFunction';


const TaskRequestHoursForm = (props: any) => {
    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(taskRequestHoursForAdd);
    const { selectedRecord, isLoading, accountprojecttaskid } = useAppSelector((state) => state.taskRequestHours);
      const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState)
    const dispatch = useAppDispatch();
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    const [requestTypeArray, SetrequestTypeArray] = useState<any | ''>([]);
    const [allocationHours, setAllocationHours] = useState(FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2));

    const getSystemTaskRequestType = async () => {
        const response = await fetchAPI("api/V2/Tasks/GetDataReuqestType", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.SystemTaskRequestTypeId;
            item.label = item.SystemTaskRequestTypeName;
            delete item.SystemTaskRequestTypeId;
            delete item.SystemTaskRequestTypeName;

        });
        setSelectedOptionDropDown({ value: json[0].value, label: json[0].label })
        SetrequestTypeArray(json);
    }


    const getAccountTaskAllocationHours = async () => {
        const response = await fetchAPI("api/V2/Tasks/GetAccountTaskAllocationHours/" + accountprojecttaskid, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        setAllocationHours(FormatInvoiceDecimalNumber(cultureInfoName.toString(), json[0].AllocationHours,2))
    }

    useEffect(() => {
        //getSystemTaskRequestType();
        getAccountTaskAllocationHours();
    }, [])



    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(taskRequestHoursForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === true ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(taskRequestHoursForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

    }, [selectedRecord])



    const handleSubmit = (values: any) => {      
        dispatch(addAccountTaskRequestasync({ ...values, 'AccountProjectTaskId': accountprojecttaskid, 'LastAllocationHours': parseLocalizedNumber(allocationHours), NewAllocationHours: parseLocalizedNumber(values.NewAllocationHours) }))
            .unwrap()
            .then((originalPromiseResult) => {
                ShowToast("Task Request Added Successfully", 'Success', "success", "toast-top-right");
            })
            .catch((rejectedValueOrSerializedError) => {
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            })
       
        oncloseModal();
    }



    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    SystemTaskRequestTypeId: 1,
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    // NewAllocationHours: yup
                    //     .number()
                    //     .min(1, getValueFromResource('Alllocation hours must be greater than 0', dispatch,t))
                    //     .max(1000, getValueFromResource('Alllocation hours must be less than or equal to 1000', dispatch,t))
                    //     .required(getValueFromResource('Alllocation hours is required', dispatch, t)),
                    NewAllocationHours: yup
  .string()
  .label(getValueFromResource('NewAllocationHours', dispatch, t))
  .test(
    'culture-format-check',
    'Invalid number format',
    function (value) {
      if (!value) return true;

      const isComma = determineCommaSeprater(
        cultureInfoName.toString()
      );

      const isValid = isComma
        ? /^\d+(,\d+)?$/.test(value)
        : /^\d+(\.\d+)?$/.test(value);

      if (!isValid) {
        return this.createError({
          message: isComma
            ? 'Only numbers and comma (,) are allowed.'
            : 'Only numbers and dot (.) are allowed.',
        });
      }

      return true;
    }
  ),

                    SystemTaskRequestTypeId: yup
                        .string()
                        .required(getValueFromResource('Request type is required.', dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog ">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? getValueFromResource('Update ', dispatch, t) : getValueFromResource('Add ', dispatch,t)} {getValueFromResource('Task Request', dispatch, t)} </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
<div className="modal-body">
    <form className='form'>
        {/* Previous Hours Section */}
        <div className='row' style={{ marginTop: 8 }}>
            <div className="col-md-12">
                <label className='timeOff-hourStatus'>
                    {getValueFromResource("PREVIOUS HOURS", dispatch, t)}
                </label>
            </div>
        </div>

        {/* Last Allocated Hours Display */}
        <div className='row mt-2'>
            <div className="col-md-12">
                <div className='timeOffHours-Separator'>
                    <span className="fw-bold d-block fs-4 tsNavBarInfoText timeOffHours-margin">
                        {allocationHours}
                    </span>
                    <span className="text-uppercase tsNavBarInfoLabel timeOffHours-margin">
                        {getValueFromResource('Last Allocated Hours', dispatch, t)}
                    </span>
                </div>
            </div>
        </div>

        {/* Allocation Hours Input */}
        <div className='row mt-4'>
            <div className="col-md-12">
                <div className="form-group">
                    <label className="fs-7 fw-normal">
                        {getValueFromResource('Allocation Hours', dispatch, t)}
                    </label>
                    <input 
                        type="text"
                        className="form-control fs-7 fw-normal"
                        id='NewAllocationHours'
                        name="NewAllocationHours"
                        value={values.NewAllocationHours}
                        onChange={handleChange('NewAllocationHours')}
                        onBlur={() => setFieldTouched('NewAllocationHours')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                setFieldTouched('NewAllocationHours', true);
                                handleSubmit();
                            }
                        }}
                    />
                    {touched.NewAllocationHours && errors.NewAllocationHours && (
                        <p className='errorMsg'>{errors.NewAllocationHours as string}</p>
                    )}
                </div>
            </div>
        </div>

        {/* Description */}
        <div className="row mt-3">
            <div className="col-md-12">
                <div className="form-group">
                    <label className="fs-7 fw-normal">
                        {getValueFromResource('Description', dispatch, t)}
                    </label>
                    <textarea 
                        className="form-control fs-7 fw-normal"
                        id='Description'
                        name='Description'
                        value={values.Description}
                        onChange={handleChange('Description')}
                        rows={3}
                    />
                </div>
            </div>
        </div>
    </form>
</div>

                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm p-2 fs-7"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm p-2 fs-7" onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {/* {t('Add Task Request')} */}
                                                            {/* {getValueFromResource('Add Task Request',dispatch, t)} */}
                                                            {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )


}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default TaskRequestHoursForm